import axios from 'axios';

// Registered once at app startup. Every file in this codebase does
// `import axios from 'axios'` (the shared default instance), so a single
// interceptor here applies globally without touching each call site.
//
// Handles the case where a logged-in session becomes invalid mid-use —
// most notably a distributor/customer account deactivated in the CRM while
// they're still browsing (see EnsureCustomerIsActive middleware on the
// backend, which revokes the token and responds 403 + reason=account_inactive).
// Without this, the app just shows blank/broken pages full of failed requests.
export const registerAuthInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const data = error?.response?.data;
      const hadToken = !!localStorage.getItem('userToken');

      // Only react to auth failures on requests that were actually
      // authenticated — avoids redirect loops on public/pre-login calls.
      if (hadToken && (status === 401 || status === 403) && window.location.pathname !== '/login') {
        const message =
          data?.reason === 'account_inactive'
            ? data.error_message || 'Your account has been deactivated. Please contact support.'
            : 'Your session has expired. Please log in again.';

        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('loginMessage', message);

        window.location.href = '/login';
      }

      return Promise.reject(error);
    }
  );
};
